export default "__VITE_ASSET__CPZxCVR9__"